import auth from "../../middlewares/auth";
export const consultationRoute = [
  {
    path: '/consultation/list',
    component: () => import(/* webpackChunkName: "consultations" */ '../../views/consultations/ConsultationList'),
    name: 'consultation_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/consultation/add',
    component: () => import(/* webpackChunkName: "consultations" */ '../../views/consultations/ConsultationForm'),
    name: 'consultation_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/consultation/edit/:id',
    component: () => import(/* webpackChunkName: "consultations" */ '../../views/consultations/ConsultationForm'),
    name: 'consultation_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];